import type { BenefitDetailDto, PersonDto } from "./benefit-types"

/** Only the identity and income facts needed to review this destructive operation. */
export function memberRemovalFacts(person: PersonDto) {
  return { personId: person.id, firstName: person.firstName, lastName: person.lastName, middleName: person.middleName,
    relationship: person.relationship, income: structuredClone(person.incomeCollection) }
}
export interface MemberRemoval {
  benefitId: string; concurrencyToken: string | null; applicantId: string
  member: ReturnType<typeof memberRemovalFacts>
}
export function captureMemberRemoval(benefit: BenefitDetailDto, personId: string): MemberRemoval | null {
  const members = benefit.personCollection.filter(person => person.id === personId)
  if (!personId || personId === benefit.applicantId || members.length !== 1) return null
  return { benefitId: benefit.id, concurrencyToken: benefit.concurrencyToken, applicantId: benefit.applicantId,
    member: memberRemovalFacts(members[0]!) }
}
export function memberRemovalCurrent(removal: MemberRemoval, benefit: BenefitDetailDto): boolean {
  const current = captureMemberRemoval(benefit, removal.member.personId)
  return !!current && JSON.stringify(current) === JSON.stringify(removal)
}
/** This endpoint carries its original token in the query, not a DELETE JSON body. */
export function memberRemovalPath(removal: MemberRemoval): string {
  return `/api/benefitapplications/${encodeURIComponent(removal.benefitId)}/household-members/${encodeURIComponent(removal.member.personId)}`
    + `?concurrencyToken=${encodeURIComponent(removal.concurrencyToken ?? "")}`
}
